import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import SKUPatternForm from './SKUPatternForm';
import { Paper, withStyles, Dialog, CircularProgress } from '@material-ui/core';
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from '../../sc-utilities';
import { connect } from 'react-redux';
import * as actions from './store/skuPatternActions';
import History from '../../../History';
import AppLogoLoading from '../../sc-logo';
import { updateKey } from '../TypicalProblem/TypicalProblemForm';

const styles = (theme) => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    submit: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        overflow: 'hidden',
        alignItems: 'center',
    },
    cancel: {
        width: '250px',
        margin: '10px',
    },
});

const SKUPatternEdit = (props) => {
    const {
        skuPattern,
        classes,
        onFetchSKUPatternInit,
        onFetchSKUPattern,
        activeCustomer,
        onEditSKUPattern,
        translations,
        permissions,
    } = props;
    const [data, setData] = useState(true);

    const handleSubmit = async (data) => {
        let objestToSend = { ...data };
        objestToSend['SKUPatternID'] = skuPattern.SKUPatternID;
        if (objestToSend['Key'] === '' || objestToSend['CustomerID'] === 'custom') {
            objestToSend['Key'] = null;
        }
        objestToSend['CustomerID'] === 'system'
            ? (objestToSend['CustomerID'] = null)
            : (objestToSend['CustomerID'] = activeCustomer);
        let result = await onEditSKUPattern({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await onFetchSKUPattern({
                ActiveCustomerID: activeCustomer,
                SKUPatternID: parseURL(window.location.href).skuPatternID,
            });
            setData(false);
        };
        fetchData();
        return () => {
            onFetchSKUPatternInit();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let initialValues = {
        Name: skuPattern.Name || '',
        Pattern: skuPattern.Pattern || '',
        ProductType: skuPattern.ProductType || '',
        CustomerID: skuPattern?.CustomerID ? 'custom' : 'system',
        Key: skuPattern?.Key
            ? skuPattern.Key
            : skuPattern.Name && skuPattern?.CustomerID
            ? updateKey(skuPattern.Name)
            : '',
    };

    const maxLengthValidationText = 'Maximum 255 characters are allowed';
    const maxLengthValidationFn = (val) => (val ? val?.length <= 255 : true);

    let formSettings = {
        Validation: {
            Name: Yup.string().required('Required').test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Pattern: Yup.string()
                .required('Required')
                .test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            ProductType: Yup.string().required('Required'),
            CustomerID: Yup.string().required('Required'),
            Key: Yup.string().required('Required'),
        },
        FormTitle: translations['edit_sku_pattern'] || 'Edit SKU pattern',
        ButtonSubmit:
            hasPermission(permissions, 'system_sku_pattern_save') ||
            (hasPermission(permissions, 'sku_pattern_save') && skuPattern.CustomerID)
                ? {
                      Title: translations['save'] || 'SAVE',
                      Color: 'primary',
                  }
                : null,
    };

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit,
                    },
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!data ? (
                <SKUPatternForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                    permissions={permissions}
                    CustomerIDPreviousState={skuPattern?.CustomerID ? 'custom' : 'system'}
                    fromEdit={true}
                />
            ) : (
                <CircularProgress variant="determinate" color="primary" size={28} />
            )}
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        skuPattern:
            state.setting.skuPatterns && state.setting.skuPatterns.loaded ? state.setting.skuPatterns.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFetchSKUPatternInit: (skuPattern) => dispatch(actions.loadSKUPatternInit(skuPattern)),
        onFetchSKUPattern: (skuPattern) => dispatch(actions.loadSKUPattern(skuPattern)),
        onEditSKUPattern: (skuPattern) => dispatch(actions.editSKUPattern(skuPattern)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(SKUPatternEdit));
